"use strict";

import {initAjaxFormMap as initAjaxFormMapGoogle} from "@elements/ajax-form-map/ajax-form-google";
import {on, find, findAll, findIn, addClass, removeClass, setAttribute} from '@elements/dom-utils';
import {onFind, initInScope} from "@elements/init-modules-in-scope";
import fetch from "@elements/fetch"
import {onEnterViewPort} from "@elements/viewport-utils";

let map;

export function init () {
    let defaultColor = "#000";
    let activeColor = "#F5240E";

    function getGooglePoiStyles(){
        return {
            default: {
                default: {
                    url: '/static/img/map/location.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                    // fillColor: defaultColor,
                    // strokeColor: defaultColor,
                    // scale: 3,
                },
                active: {
                    url: '/static/img/map/location-active.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                    // fillColor: activeColor,
                    // scale: 3,
                }
            },
            office: {
                default: {
                    url: '/static/img/map/location-office.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),

                },
                active: {
                    url: '/static/img/map/location-active.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                    fillColor: activeColor,
                }
            },
            partner: {
                default: {
                    url: '/static/img/map/location-partner.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                },
                active: {
                    url: '/static/img/map/location-active.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                    fillColor: activeColor,
                }
            },
            showroom: {
                default: {
                    url: '/static/img/map/location-showroom.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                },
                active: {
                    url: '/static/img/map/location-active.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                    fillColor: activeColor,
                }
            },
            sales: {
                default: {
                    url: '/static/img/map/location-sales.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                },
                active: {
                    url: '/static/img/map/location-active.svg',
                    origin: new google.maps.Point(0, 0),
                    scaledSize: new google.maps.Size(60, 60),
                    fillColor: activeColor,
                }
            },
        };
    }

    function getGoogleInfoBoxOptions(){
        let width = matchMedia('(max-width: 767px)').matches ? "260px" : "290px";

        return {
            pixelOffset: new google.maps.Size(0, 240),
            boxStyle: {width: width, padding: "0"},
            boxClass: "map-infobox-container",
            closeBoxURL: ""
        };
    }

    function onActivateMarker(marker, api) {
        if (marker.detailInfoBoxUrl) {
            let infoBoxPromise = api.showInfoBoxByMarker(
                marker,
                ` <div class="loading-spinner" aria-label="loading...">
                    <div class="loading-spinner__item loading-spinner__item--1"></div>
                    <div class="loading-spinner__item loading-spinner__item--2"></div>
                    <div class="loading-spinner__item loading-spinner__item--3"></div>
                </div>`
            );

            let contentPromise = fetch(marker.detailInfoBoxUrl, {
                method: 'GET',
                headers: {"content-type": "application/json"}
            }).then((res) => {
                return res.json()
            });


            Promise.all([infoBoxPromise, contentPromise]).then(([infoBox, response]) => {
                infoBox.setContent(response.html);

                let t = setTimeout(function () {
                    if (infoBox.div_) {
                        initInScope(infoBox.div_);
                    }

                    clearTimeout(t);
                }, 100);
            });
        }

        let teaser = find('.js-single-location[data-poi-id="' + marker.dataId + '"]');
        if (teaser) {
            let offset = teaser.offsetTop;
            if (teaser.offsetTop > window.innerHeight / 2 + window.scrollY - find('.js-nav-container').getBoundingClientRect().height) {
                offset = teaser.offsetTop - window.innerHeight + teaser.getBoundingClientRect().height + find('.js-nav-container').getBoundingClientRect().height
            }
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });

            addClass('is-active', teaser);
        }
    }

    function onDeactivateMarker(marker, api) {
        api.closeInfoBoxByMarker(marker);

        findAll('.js-single-location').map((teaser) => {
            removeClass('is-active', teaser);
        });
    }

    findAll('.js-ajax-form-map').map(googleMap => {
        let lat = +googleMap.getAttribute('data-google-map-lat') || 47.2183939;
        let lng = +googleMap.getAttribute('data-google-map-lng') || 14.306775;

        let clusteringOptions = {
            default: {
                styles: [{
                    url: '/static/img/map/location.svg',
                    height: 60,
                    width: 60,
                    textSize: 25,
                    textColor: "#FFF",
                }]
            },
            office: {
                styles: [{
                    url: '/static/img/map/location-office.svg',
                    height: 60,
                    width: 60,
                    textSize: 25,
                    textColor: "#FFF",
                }]
            },
            partner: {
                styles: [{
                    url: '/static/img/map/location-partner.svg',
                    height: 60,
                    width: 60,
                    textSize: 25,
                    textColor: "#FFF",
                }]
            }
        };

        let selectors = {
            result: '.js-ajax-form-map__result',
            loading: '.js-ajax-form-map__loading',
            notifications: '.js-ajax-form-map__notifications',
            form: '.js-ajax-form-map__form',
            additionalForm: '.js-ajax-form-map__additional-form',
            errorArea: '.js-ajax-form-map__error-area',
            retry: '.js-ajax-form-map__retry',
            link: '.js-ajax-form-map__link',
            reset: '.js-ajax-form-map__reset',
        };

        let mapStyle = [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "lightness": "-22"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ];

        map = initAjaxFormMapGoogle(googleMap, {
            element: findIn('.js-ajax-form-map__map__canvas', googleMap),
            poiStyles: () => getGooglePoiStyles(),
            infoBoxOptions: () => getGoogleInfoBoxOptions(),
            clustering: true,
            clusteringOptions,
            onActivateMarker: (marker, api) => onActivateMarker(marker, api),
            onDeactivateMarker: (marker, api) => onDeactivateMarker( marker, api),
            mapOptions: {
                zoom: 7,
                scrollwheel: true,
                mapTypeControl: false,
                streetViewControl: false,
                styles: mapStyle
            },
            consentRenderFunction: () => {
                const consentOverlay = findIn('.js-consent', googleMap);
                return new Promise((resolve, reject) => {
                    let onChangeListening = false;
                    const originalWrapper = window.OptanonWrapper;

                    if (originalWrapper) {
                        window.OptanonWrapper = () => {
                            originalWrapper();

                            if (OnetrustActiveGroups.includes('C0003')) {
                                resolve();

                                if (consentOverlay) {
                                    consentOverlay.remove();
                                }
                            }else{
                                if (consentOverlay.getAttribute('hidden')) {
                                    consentOverlay.removeAttribute('hidden');
                                }
                            }

                            if (OneTrust && !onChangeListening) {
                                onChangeListening = true;

                                OneTrust.OnConsentChanged(() => {
                                    if (OnetrustActiveGroups.includes('C0003')) {
                                        resolve();

                                        if (consentOverlay) {
                                            consentOverlay.remove();
                                        }
                                    }
                                });
                            }
                        }
                    }
                });
            }
        }, selectors);

        onEnterViewPort(findIn('.js-ajax-form-map__map__canvas', googleMap), function () {
            map.mapObj.then((mapObj) => {
                mapObj.centerMap();

                onFind('.js-single-location', function (location) {
                    on('click', ()=> {
                        let locationId = location.getAttribute('data-poi-id');
                        mapObj.getMarkers().map((marker) => {
                            if (marker.dataId === locationId) {
                                mapObj.getMapInstance().setZoom(10)
                                mapObj.activateMarker(marker)
                                mapObj.scrollToMarkers([marker])
                            }
                        })
                    }, location)
                })
            })
        }, {
            offset: window.innerHeight * 1.5
        });
    });
}

export function getMap() {
    return map;
}